import React from 'react';

const Checkbox = ({answers}) => {
    const boxes = answers.map((answer, index) =>
      <li key={index}><input type="checkbox" value={answer.value || answer} /> { answer.text || answer }</li>
    )
    return(
      <ul>
        { boxes }
      </ul>
    )
}
export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox.js